import React, {useCallback, useEffect, useState} from 'react';
import logo from 'assets/svg/logo.svg';
import {Link} from "react-router-dom";

const Header = () => {
  const [classes, setClasses] = useState('');
  const [isMounted, setIsMounted] = useState(true);

  const changeBackground = useCallback(() => {
    if (isMounted) {
      const newClasses = window.scrollY >= 66 ? 'bg-white shadow-lg' : 'bg-white';

      setClasses(newClasses);
    }
  }, [isMounted])

  useEffect(() => {
    setIsMounted(true)
    changeBackground()
    window.addEventListener("scroll", changeBackground)

    return () => setIsMounted(false)
  }, [changeBackground])

  return (
    <nav className={`${classes} transition duration-300 fixed w-full justify-around z-30`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8 3xl:px-0 md:block my-3">
        <div className="relative flex items-center justify-between h-10">
          <div className="flex items-center justify-center sm:items-stretch sm:justify-start">
            <a href='https://www.one.al/'>
              <img className="h-8 md:h-10" src={logo} alt="Logo"/>
            </a>
          </div>
        </div>
      </div>
    </nav>
  );
}

export default Header

